import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledComponent = styled(({css, ...rest}) => <pre {...rest} />)`
  font-size: 22px;
  color: #a80000;
  display: block;
  ${p => p.css}
`

const _ErrorMessage = (props) => <StyledComponent {...props} />
_ErrorMessage.propTypes = {
  css: PropTypes.string,
}

export default _ErrorMessage

